// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListSettingsManagement-commonHeaderAdmin-XcXIy {
	position: fixed !important;
}

.ListSettingsManagement-adminLayout-VVJaF {
	padding-top: 64px !important;
}

.ListSettingsManagement-box-lzjcs h2 {
	font-size: 21px;
	font-weight: 600;
}

.ListSettingsManagement-exportLink-XaeaD {
	margin-bottom: -29px;
}

.ListSettingsManagement-blockCenter-Qawaj {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.ListSettingsManagement-panelHeader-Lj3gQ {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.ListSettingsManagement-currencyselect-O8aiG {
	width: 100%;
	margin-right: 0px;
}

.ListSettingsManagement-panelHeader-Lj3gQ {
	overflow: hidden;
	position: relative;
}

.ListSettingsManagement-mar0-eKygx {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.ListSettingsManagement-blockCenter-Qawaj {
		padding: 0px;
	}

	.ListSettingsManagement-panelHeader-Lj3gQ {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.ListSettingsManagement-sideAdminPageWrapper-CQZut {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.ListSettingsManagement-panelHeader-Lj3gQ {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.ListSettingsManagement-table-LbpBq {
	display: table;
}

.ListSettingsManagement-tableRow-R6YZ_ {
	display: table-row;
}

.ListSettingsManagement-tableCell-F9rNf {
	display: table-cell;
	float: none;
}

.ListSettingsManagement-formGroup-Md9VK {
	margin-bottom: 6px;
}

.ListSettingsManagement-select-DI1fU {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.ListSettingsManagement-noMargin-sR3kq {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.ListSettingsManagement-exportLink-XaeaD {
	padding-top: 10px;
	padding-right: 10px;
}

.ListSettingsManagement-labelTextNew-npp2D {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.ListSettingsManagement-displayInline-admTT {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.ListSettingsManagement-btnUPdate-ibWO7 {
	display: inline-block;
}

.ListSettingsManagement-btnModalDelete-GikXj {
	display: inline-block;
	margin-left: 15px;
}

.ListSettingsManagement-radioBtn-iid_X {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.ListSettingsManagement-backgroundImg-xOXO1 {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.ListSettingsManagement-btnUPdate-ibWO7 {
		display: block;
		margin-bottom: 12px;
	}

	.ListSettingsManagement-btnModalDelete-GikXj {
		display: block;
		margin-left: 0px;
	}

	.ListSettingsManagement-btnWidth-E7X_I {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.ListSettingsManagement-bannerImageBg-CVXe2 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.ListSettingsManagement-bannerDelete-etj7o {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.ListSettingsManagement-modalRoot-Y9jT4 {
	padding: 32px;
}

.ListSettingsManagement-modalBorderBottom-RMQjV {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.ListSettingsManagement-logInModalBody-bbEFE {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.ListSettingsManagement-exportSection-rAAXM {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.ListSettingsManagement-exportSectionGridSub-NrqYH {
	grid-template-columns: 50% 49% !important;
}

.ListSettingsManagement-exportText-lQeLI {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.ListSettingsManagement-exportLinkImg-UUnys {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.ListSettingsManagement-vtrMiddle-lYNNW {
	vertical-align: middle;
}

.ListSettingsManagement-exportImg-JoAel {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ListSettingsManagement-profileViewlabel-OK5dv {
	display: inline-block;
	width: 38%
}

.ListSettingsManagement-profileViewMainContent-y10jo {
	display: inline-block;
	width: 62%;
}

.ListSettingsManagement-profileViewMain-TJP8o {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.ListSettingsManagement-profileViewInner-ds9z7 {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.ListSettingsManagement-profileImageSection-NENX4 {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.ListSettingsManagement-lastviewInner-eJe8l {
	padding: 10px;
}

.ListSettingsManagement-whyHostHoriLine-DddHy {
	margin: 30px 0;
}

.ListSettingsManagement-tableGrid-xs1Xo {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.ListSettingsManagement-headingContent-rPOnH {
	font-size: 18px;
	font-weight: 500;
}

.ListSettingsManagement-refundTextColor-Fe5uO {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.ListSettingsManagement-dividerLine-o86Ku {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ListSettingsManagement-smallContent-vmPuB {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.ListSettingsManagement-sideAdminPageWrapper-CQZut {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.ListSettingsManagement-sideAdminPageWrapper-CQZut {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.ListSettingsManagement-exportSection-rAAXM {
		grid-template-columns: 100%;
	}

	.ListSettingsManagement-exportSectionGridSub-NrqYH {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.ListSettingsManagement-profileViewlabel-OK5dv {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ListSettingsManagement-profileViewMainContent-y10jo {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.ListSettingsManagement-ChangeToUpperCase-kfU1a {
	text-transform: uppercase
}

.ListSettingsManagement-noBorder-btiYg {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.ListSettingsManagement-siteAdminHeading-xYcs3 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.ListSettingsManagement-siteAdminSubHeading-E_vzR {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.ListSettingsManagement-adminFormDivider-mvUQz {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.ListSettingsManagement-errorMessage-meGWD {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.ListSettingsManagement-panelHeader-Lj3gQ {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.ListSettingsManagement-formGroup-Md9VK {
  margin-bottom: 6px;
}

.ListSettingsManagement-select-DI1fU {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.ListSettingsManagement-labelText-kwsXH {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.ListSettingsManagement-space1-LX3Ay {
	margin-bottom: 6px !important;
}

.ListSettingsManagement-space2-L75cw {
	margin-bottom: 12px !important;
}

.ListSettingsManagement-space3-Mr3Cf {
	margin-bottom: 18px !important;
}

.ListSettingsManagement-space4-fu3r8 {
	margin-bottom: 24px !important;
}

.ListSettingsManagement-space5-T26V7 {
	margin-bottom: 30px !important;
}

.ListSettingsManagement-space6-F9Y1V {
	margin-bottom: 36px !important;
}

.ListSettingsManagement-space7-U2XsY {
	margin-bottom: 42px !important;
}

.ListSettingsManagement-spaceTop8-_dGln {
	margin-bottom: 48px !important;
}

.ListSettingsManagement-spaceTop1-iCif9 {
	margin-top: 6px !important;
}

.ListSettingsManagement-spaceTop2-aDOxp {
	margin-top: 12px !important;
}

.ListSettingsManagement-spaceTop3-waG8p {
	margin-top: 18px !important;
}

.ListSettingsManagement-spaceTop4-uWQtB {
	margin-top: 24px !important;
}

.ListSettingsManagement-spaceTop5-nNDZG {
	margin-top: 30px !important;
}

.ListSettingsManagement-spaceTop6-crXZ7 {
	margin-top: 36px !important;
}

.ListSettingsManagement-spaceTop7-YZt5S {
	margin-top: 42px !important;
}

.ListSettingsManagement-spaceTop8-_dGln {
	margin-top: 48px !important;
}

.ListSettingsManagement-noMargin-sR3kq {
	margin: 0px !important;
}

.ListSettingsManagement-padding1-YmMc_ {
	padding-bottom: 6px !important;
}

.ListSettingsManagement-padding2-TZ2ui {
	padding-bottom: 12px !important;
}

.ListSettingsManagement-padding3-JliKK {
	padding-bottom: 18px !important;
}

.ListSettingsManagement-padding4-lzbqT {
	padding-bottom: 24px !important;
}

.ListSettingsManagement-padding5-JRFSP {
	padding-bottom: 30px !important;
}

.ListSettingsManagement-padding6-EdoyP {
	padding-bottom: 36px !important;
}

.ListSettingsManagement-padding7-RbSuI {
	padding-bottom: 42px !important;
}

.ListSettingsManagement-paddingTop1-wntZk {
	padding-top: 6px !important;
}

.ListSettingsManagement-paddingTop2-Uy9Dh {
	padding-top: 12px !important;
}

.ListSettingsManagement-paddingTop3-CDqWl {
	padding-top: 18px !important;
}

.ListSettingsManagement-paddingTop4-zv9_m {
	padding-top: 24px !important;
}

.ListSettingsManagement-paddingTop5-l_FIN {
	padding-top: 30px !important;
}

.ListSettingsManagement-paddingTop6-N8gD3 {
	padding-top: 36px !important;
}

.ListSettingsManagement-paddingTop7-eiRE2 {
	padding-top: 42px !important;
}

.ListSettingsManagement-noPadding-ZUrb3 {
	padding: 0px !important;
}

.ListSettingsManagement-textBold-jbXjr {
	font-weight: 500 !important;
}

.ListSettingsManagement-textBolder-W8KbL {
	font-weight: 700 !important;
}

.ListSettingsManagement-textNormal-s8SN1 {
	font-weight: normal !important;
}

.ListSettingsManagement-spaceBottom20-ldSoc {
	margin-bottom: 20px;
}

.ListSettingsManagement-spaceBottom10-pHfpg {
	margin-bottom: 10px;
}

.ListSettingsManagement-marginNone-ik6_e {
	margin: 0;
}

.ListSettingsManagement-spaceBottom15-A5cX2 {
	margin-bottom: 15px;
}

.ListSettingsManagement-marginTopNone-xTHs6 {
	margin-top: 0;
}

.ListSettingsManagement-spaceTop11-XvXs7 {
	margin-top: 11px;
}

.ListSettingsManagement-spaceTop21-jRq2w {
	margin-top: 21px;
}

.ListSettingsManagement-spaceTop20-HuIIt {
	margin-top: 20px;
}

.ListSettingsManagement-spaceTop10-WCnAr {
	margin-top: 10px;
}

/*New Design Text Colors */

.ListSettingsManagement-textDarkBlue-looQi {
	color: rgb(20, 39, 94) !important;
}

.ListSettingsManagement-textLightBlue-cquKK {
	color: rgb(57, 87, 106) !important;
}

.ListSettingsManagement-textLightSandleGreen-kA8AT {
	color: rgb(76, 86, 41) !important;
}

.ListSettingsManagement-textLightBrown-W4VBe {
	color: rgb(115, 79, 33) !important;
}

.ListSettingsManagement-textMediumMaroon-vaTRe {
	color: rgb(87, 37, 51) !important;
}

.ListSettingsManagement-textBrown-wxce2 {
	color: rgb(160, 47, 24) !important;
}

.ListSettingsManagement-textMaroon-idFqv {
	color: rgb(155, 49, 67) !important;
}

.ListSettingsManagement-textDarkBrown-pXEjC {
	color: rgb(83, 18, 16) !important;
}

.ListSettingsManagement-textMediumBrown-R12vU {
	color: rgb(142, 28, 10) !important;
}

.ListSettingsManagement-textSkyBlue-ZnJOq {
	color: rgb(37, 117, 141) !important;
}

.ListSettingsManagement-textGray-pfBqn {
	color: rgb(77, 65, 51) !important;
}

.ListSettingsManagement-nxtLineStyle-mqQQB {
    white-space: pre-line;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/ListSettingsManagement/ListSettingsManagement.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,qBAAqB;AACzB","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../admin-form.css';\n@import '../../helpers.css';\n\n.nxtLineStyle {\n    white-space: pre-line;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `ListSettingsManagement-commonHeaderAdmin-XcXIy`,
	"adminLayout": `ListSettingsManagement-adminLayout-VVJaF`,
	"box": `ListSettingsManagement-box-lzjcs`,
	"exportLink": `ListSettingsManagement-exportLink-XaeaD`,
	"blockCenter": `ListSettingsManagement-blockCenter-Qawaj`,
	"panelHeader": `ListSettingsManagement-panelHeader-Lj3gQ`,
	"currencyselect": `ListSettingsManagement-currencyselect-O8aiG`,
	"mar0": `ListSettingsManagement-mar0-eKygx`,
	"sideAdminPageWrapper": `ListSettingsManagement-sideAdminPageWrapper-CQZut`,
	"table": `ListSettingsManagement-table-LbpBq`,
	"tableRow": `ListSettingsManagement-tableRow-R6YZ_`,
	"tableCell": `ListSettingsManagement-tableCell-F9rNf`,
	"formGroup": `ListSettingsManagement-formGroup-Md9VK`,
	"select": `ListSettingsManagement-select-DI1fU`,
	"noMargin": `ListSettingsManagement-noMargin-sR3kq`,
	"labelTextNew": `ListSettingsManagement-labelTextNew-npp2D`,
	"displayInline": `ListSettingsManagement-displayInline-admTT`,
	"btnUPdate": `ListSettingsManagement-btnUPdate-ibWO7`,
	"btnModalDelete": `ListSettingsManagement-btnModalDelete-GikXj`,
	"radioBtn": `ListSettingsManagement-radioBtn-iid_X`,
	"backgroundImg": `ListSettingsManagement-backgroundImg-xOXO1`,
	"btnWidth": `ListSettingsManagement-btnWidth-E7X_I`,
	"bannerImageBg": `ListSettingsManagement-bannerImageBg-CVXe2`,
	"bannerDelete": `ListSettingsManagement-bannerDelete-etj7o`,
	"modalRoot": `ListSettingsManagement-modalRoot-Y9jT4`,
	"modalBorderBottom": `ListSettingsManagement-modalBorderBottom-RMQjV`,
	"logInModalBody": `ListSettingsManagement-logInModalBody-bbEFE`,
	"exportSection": `ListSettingsManagement-exportSection-rAAXM`,
	"exportSectionGridSub": `ListSettingsManagement-exportSectionGridSub-NrqYH`,
	"exportText": `ListSettingsManagement-exportText-lQeLI`,
	"exportLinkImg": `ListSettingsManagement-exportLinkImg-UUnys`,
	"vtrMiddle": `ListSettingsManagement-vtrMiddle-lYNNW`,
	"exportImg": `ListSettingsManagement-exportImg-JoAel`,
	"profileViewlabel": `ListSettingsManagement-profileViewlabel-OK5dv`,
	"profileViewMainContent": `ListSettingsManagement-profileViewMainContent-y10jo`,
	"profileViewMain": `ListSettingsManagement-profileViewMain-TJP8o`,
	"profileViewInner": `ListSettingsManagement-profileViewInner-ds9z7`,
	"profileImageSection": `ListSettingsManagement-profileImageSection-NENX4`,
	"lastviewInner": `ListSettingsManagement-lastviewInner-eJe8l`,
	"whyHostHoriLine": `ListSettingsManagement-whyHostHoriLine-DddHy`,
	"tableGrid": `ListSettingsManagement-tableGrid-xs1Xo`,
	"headingContent": `ListSettingsManagement-headingContent-rPOnH`,
	"refundTextColor": `ListSettingsManagement-refundTextColor-Fe5uO`,
	"dividerLine": `ListSettingsManagement-dividerLine-o86Ku`,
	"smallContent": `ListSettingsManagement-smallContent-vmPuB`,
	"ChangeToUpperCase": `ListSettingsManagement-ChangeToUpperCase-kfU1a`,
	"noBorder": `ListSettingsManagement-noBorder-btiYg`,
	"siteAdminHeading": `ListSettingsManagement-siteAdminHeading-xYcs3`,
	"siteAdminSubHeading": `ListSettingsManagement-siteAdminSubHeading-E_vzR`,
	"adminFormDivider": `ListSettingsManagement-adminFormDivider-mvUQz`,
	"errorMessage": `ListSettingsManagement-errorMessage-meGWD`,
	"labelText": `ListSettingsManagement-labelText-kwsXH`,
	"space1": `ListSettingsManagement-space1-LX3Ay`,
	"space2": `ListSettingsManagement-space2-L75cw`,
	"space3": `ListSettingsManagement-space3-Mr3Cf`,
	"space4": `ListSettingsManagement-space4-fu3r8`,
	"space5": `ListSettingsManagement-space5-T26V7`,
	"space6": `ListSettingsManagement-space6-F9Y1V`,
	"space7": `ListSettingsManagement-space7-U2XsY`,
	"spaceTop8": `ListSettingsManagement-spaceTop8-_dGln`,
	"spaceTop1": `ListSettingsManagement-spaceTop1-iCif9`,
	"spaceTop2": `ListSettingsManagement-spaceTop2-aDOxp`,
	"spaceTop3": `ListSettingsManagement-spaceTop3-waG8p`,
	"spaceTop4": `ListSettingsManagement-spaceTop4-uWQtB`,
	"spaceTop5": `ListSettingsManagement-spaceTop5-nNDZG`,
	"spaceTop6": `ListSettingsManagement-spaceTop6-crXZ7`,
	"spaceTop7": `ListSettingsManagement-spaceTop7-YZt5S`,
	"padding1": `ListSettingsManagement-padding1-YmMc_`,
	"padding2": `ListSettingsManagement-padding2-TZ2ui`,
	"padding3": `ListSettingsManagement-padding3-JliKK`,
	"padding4": `ListSettingsManagement-padding4-lzbqT`,
	"padding5": `ListSettingsManagement-padding5-JRFSP`,
	"padding6": `ListSettingsManagement-padding6-EdoyP`,
	"padding7": `ListSettingsManagement-padding7-RbSuI`,
	"paddingTop1": `ListSettingsManagement-paddingTop1-wntZk`,
	"paddingTop2": `ListSettingsManagement-paddingTop2-Uy9Dh`,
	"paddingTop3": `ListSettingsManagement-paddingTop3-CDqWl`,
	"paddingTop4": `ListSettingsManagement-paddingTop4-zv9_m`,
	"paddingTop5": `ListSettingsManagement-paddingTop5-l_FIN`,
	"paddingTop6": `ListSettingsManagement-paddingTop6-N8gD3`,
	"paddingTop7": `ListSettingsManagement-paddingTop7-eiRE2`,
	"noPadding": `ListSettingsManagement-noPadding-ZUrb3`,
	"textBold": `ListSettingsManagement-textBold-jbXjr`,
	"textBolder": `ListSettingsManagement-textBolder-W8KbL`,
	"textNormal": `ListSettingsManagement-textNormal-s8SN1`,
	"spaceBottom20": `ListSettingsManagement-spaceBottom20-ldSoc`,
	"spaceBottom10": `ListSettingsManagement-spaceBottom10-pHfpg`,
	"marginNone": `ListSettingsManagement-marginNone-ik6_e`,
	"spaceBottom15": `ListSettingsManagement-spaceBottom15-A5cX2`,
	"marginTopNone": `ListSettingsManagement-marginTopNone-xTHs6`,
	"spaceTop11": `ListSettingsManagement-spaceTop11-XvXs7`,
	"spaceTop21": `ListSettingsManagement-spaceTop21-jRq2w`,
	"spaceTop20": `ListSettingsManagement-spaceTop20-HuIIt`,
	"spaceTop10": `ListSettingsManagement-spaceTop10-WCnAr`,
	"textDarkBlue": `ListSettingsManagement-textDarkBlue-looQi`,
	"textLightBlue": `ListSettingsManagement-textLightBlue-cquKK`,
	"textLightSandleGreen": `ListSettingsManagement-textLightSandleGreen-kA8AT`,
	"textLightBrown": `ListSettingsManagement-textLightBrown-W4VBe`,
	"textMediumMaroon": `ListSettingsManagement-textMediumMaroon-vaTRe`,
	"textBrown": `ListSettingsManagement-textBrown-wxce2`,
	"textMaroon": `ListSettingsManagement-textMaroon-idFqv`,
	"textDarkBrown": `ListSettingsManagement-textDarkBrown-pXEjC`,
	"textMediumBrown": `ListSettingsManagement-textMediumBrown-R12vU`,
	"textSkyBlue": `ListSettingsManagement-textSkyBlue-ZnJOq`,
	"textGray": `ListSettingsManagement-textGray-pfBqn`,
	"nxtLineStyle": `ListSettingsManagement-nxtLineStyle-mqQQB`
};
module.exports = ___CSS_LOADER_EXPORT___;
